export default __webpack_public_path__ + "static/media/studio-3.79716c37.jpg";